import React from 'react';
import { useTranslation } from 'react-i18next';
export var GenericLabel = function () {
    var t = useTranslation().t;
    return (React.createElement("span", { className: "relative flex w-full text-sm mobile:text-base" }, t('feedbackModal.generic.question.label', 'More details (optional)')));
};
